import { Autocomplete, Grid, TextField, Typography } from '@mui/material'
import axios from 'axios'
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import { useStyle } from '../../billing/style'
import CustomTable from '../customTable'
import { Helmet } from 'react-helmet-async'

const Products = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data, setData] = useState([])
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [headData, setHeadData] = useState([])
    const [typeData, setTypeData] = useState([])
    const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
   const [allSubData, setAllSubData] = useState([]);

    const [options, setOptions] = useState({
        head: null,
        type: null,
        category : null,
        subCategory : null
    })

    function handleChange(value, name){
        console.log(name, value)
        setOptions(prev=>({...prev,[name] : value}))
        
  if (name === "category") {
    // setCategoryError(''); // Clear any category error
    setOptions((prev) => ({ ...prev, subCategory: null,})); // Reset subcategory, brand, and type
    filterSubCategories(value ? value.id : null); // Fetch subcategories based on selected category
  }
    }
    function getItemData(){
        axios.get(`/v1/reports/item/${options.head===null ? 0 : options.head.id}/${options.type===null ? 0 : options.type.id}/${options.category===null ? 0 : options.category.id}/${options.subCategory===null ? 0 : options.subCategory.id}/${rowsPerPage}/${page + 1}`)
        .then(res=>{
            setData(res.data.data)
            setPageCount(res.data.meta.pagination.total)
        })
        .catch(err=>{
            console.log(err)
            setData([])
            setPageCount([])
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getHead(){
        axios.get('/v1/Head')
        .then(res=>{
            setHeadData(res.data)
        })
        .catch(err=>{
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getTypeData(){
        axios.get('/v1/typedesign')
        .then(res=>{
            setTypeData(res.data)
        })
        .catch(err=>{
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getCategory(){
        axios.get('/v1/categories')
        .then(res=>{
            _.filter(res.data, val=>{
                if(val.is_active){
                     setCatData(res.data)
                }
            })
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getSubCategory(){
        axios.get('/v1/subcategories')
        .then(res=>{
          setAllSubData(res.data)
                // setSubData(res.data)
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function filterSubCategories(categoryId) {
      if (categoryId) {
        const filteredSubData = allSubData.filter(
          (sub) => sub.category_id === categoryId
        );
        setSubData(filteredSubData);
      } else {
        setSubData([]);
      }
    }
    const columns = [
        {
            field : 'sno',
            headerName :'S.no',
            minWidth: 70,
            maxWidth: 100,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "code",
            headerName: "Product Code",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "item",
            headerName: "Product Name",
            flex:1,
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "unit",
            headerName: "Unit",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "mrp",
            headerName: "MRP",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "purrate",
            headerName: "Purchase Rate",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "salesRate",
            headerName: "Sales Rate",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "gst",
            headerName: "GST",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "hsn",
            headerName: "Hsn",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          // {
          //   field: "cess",
          //   headerName: "Cess",
          //   minWidth: 150,
          //   headerAlign: "center",
          //   align: "center",
          //   sortable: false,
          // },
          {
            field: "balance",
            headerName: "Balance",
            minWidth: 180,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
    ]
    const rows = _.map(data,(val,idx)=>({
        id: val.id,
        sno: idx + 1,
        code: val.pro_code,
        item : val.pro_name,
        unit: val.uom_name,
        mrp : Math.round(val.mrp).toFixed(0),
        purrate: Math.round(val.pur_rate).toFixed(0),
        salesRate : Math.round(val.sale_rate).toFixed(0),
        gst: val.gst,
        cess : val.cess,
        balance : parseFloat(val.balance).toFixed(0),
        hsn:val.hsn
    }))
   
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
        totalAmount:totalAmount,
        totalFlag:totalFlag
    }
    useEffect(() => {
      // Calculate total balance amount
      setTotalFlag(true)
      let total = 0;

      data.forEach(val => {
          total += parseFloat(val.balance);
      });
      setTotalAmount(total.toFixed(0));
  }, [data]);
    useEffect(()=>{
        getCategory()
        getSubCategory()
        getHead()
        getTypeData()
    },[])
    useEffect(()=>{
        getItemData()
    },[rowsPerPage, page, options])
    console.log("first")
  return (
    <Fragment>
      <Helmet><title>Products Wise</title></Helmet>
            <Typography variant="h5">Products Wise</Typography>
    <Grid container spacing={2} className='p-2 pt-2'>
    <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.head}
        options={headData}
        getOptionLabel={option=>option.cateogory_name}
        onChange={(e,value)=>handleChange(value,'head')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Brand'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={typeData}
        value={options.type}
        getOptionLabel={option=>option.type_name}
        onChange={(e,value)=>handleChange(value,'type')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Type Design'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleChange(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleChange(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
    </Grid>
<CustomTable props={props} />
    </Fragment>
  )
}

export default Products